const createGmapMarkerIcon = (index, color, numberColor) => {
    return `data:image/svg+xml;charset=UTF-8,%3Csvg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"%3E%3Ccircle cx="15" cy="15" r="12" fill="%23${color}" /%3E%3Ctext x="50%" y="50%" text-anchor="middle" fill="%23${numberColor}" font-size="14" dy=".3em"%3E${index}%3C/text%3E%3C/svg%3E`
}

const createGmapMarkerIconCar = (color) => {
    const svg = `
    <svg width="40" height="40" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="#${color}" />
      <path fill="white" d="M5 11l1.5-4.5h11L19 11M17.5 16a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5m-11 0A1.5 1.5 0 0 1 5 14.5A1.5 1.5 0 0 1 6.5 13A1.5 1.5 0 0 1 8 14.5A1.5 1.5 0 0 1 6.5 16M18.92 6c-.2-.58-.76-1-1.42-1h-11c-.66 0-1.22.42-1.42 1L3 12v8a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-8z"/>
    </svg>
  `;
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
};

export { createGmapMarkerIcon, createGmapMarkerIconCar }